import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

export const ETS1_MAX_REMINDER_NOTES = 10;
export const ETS1_REMINDER_NOTE_MAX_LENGTH = 1000;

export type Ets1ReminderNoteValue = {
	text: string;
	requireStatus?: boolean;
};

export function createReminderNoteGroup(
	fb: UntypedFormBuilder,
	note: Ets1ReminderNoteValue = { text: "", requireStatus: false },
): UntypedFormGroup {
	return fb.group({
		text: [note.text ?? "", [Validators.maxLength(ETS1_REMINDER_NOTE_MAX_LENGTH)]],
		requireStatus: [!!note.requireStatus],
	});
}

export function patchReminderNotesFormArray(
	fb: UntypedFormBuilder,
	formArray: UntypedFormArray,
	notes: Ets1ReminderNoteValue[] = [],
): void {
	while (formArray.length) formArray.removeAt(0);
	for (const note of notes) {
		formArray.push(createReminderNoteGroup(fb, note));
	}
}

export function addReminderNote(formArray: UntypedFormArray, fb: UntypedFormBuilder): boolean {
	if (formArray.length >= ETS1_MAX_REMINDER_NOTES) return false;
	formArray.push(createReminderNoteGroup(fb));
	return true;
}

export function removeReminderNote(formArray: UntypedFormArray, index: number): void {
	if (index < 0 || index >= formArray.length) return;
	formArray.removeAt(index);
}

export function normalizeReminderNotesForSubmit(
	notes: Array<{ text?: string; requireStatus?: boolean }>,
): Ets1ReminderNoteValue[] {
	return notes
		.map((note) => ({
			text: String(note.text ?? "").trim().slice(0, ETS1_REMINDER_NOTE_MAX_LENGTH),
			requireStatus: !!note.requireStatus,
		}))
		.filter((note) => note.text.length > 0);
}
